import { DatePipe } from "@angular/common";
import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from "@angular/material/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withHashLocation } from "@angular/router";
import { WebserviceService } from "src/services/webservice";
import { AppRoutes } from "./app.routes";
// import { provideHttpClient } from "@angular/common/http";
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { CookieService } from "ngx-cookie-service";
import { NgxSpinnerModule } from "ngx-spinner";
import { aesEncryptionInterceptor } from "./aes-encryption.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(AppRoutes, withHashLocation()),
    importProvidersFrom(
      NgbModule,
      MatSnackBarModule,
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      }),
      NgxSpinnerModule.forRoot(),
      NgSelectModule,
    ),
    provideHttpClient(withInterceptors([aesEncryptionInterceptor])),

    WebserviceService,
    DatePipe,
    provideNativeDateAdapter(),
    provideAnimations(),
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    CookieService,
  ],
};
